/**
 * Voice AI — Calls Stats Bar
 * Renders 4 mini-stat cards: Total Calls, Completed %, Avg Duration, Total Minutes.
 */

import { LitElement, html } from 'lit';
import { designSystem } from '../../styles/design-system.js';
import { callsStyles } from '../../styles/calls-styles.js';
import { iconStyles } from '../../styles/icon-styles.js';
import { callsService } from '../../services/calls-service.js';

export class CallsStatsBar extends LitElement {
  static properties = {
    stats: { type: Object },
    loading: { type: Boolean },
  };

  static styles = [designSystem, callsStyles];

  constructor() {
    super();
    this.stats = { total: 0, completedPct: 0, avgDuration: 0, totalMinutes: 0 };
    this.loading = false;
  }

  render() {
    const s = this.stats;
    const sk = this.loading;
    return html`
      ${iconStyles}
      <div class="stats-bar">
        <div class="mini-stat ${sk ? 'skeleton-stat' : ''}">
          <div class="mini-stat-icon calls">
            <i class="fa-sharp-duotone fa-solid fa-phone"></i>
          </div>
          <div class="mini-stat-content">
            <span class="mini-stat-value">${sk ? '—' : (s.total || 0).toLocaleString()}</span>
            <span class="mini-stat-label">Total Calls</span>
          </div>
        </div>
        <div class="mini-stat ${sk ? 'skeleton-stat' : ''}">
          <div class="mini-stat-icon completed">
            <i class="fa-sharp-duotone fa-solid fa-circle-check"></i>
          </div>
          <div class="mini-stat-content">
            <span class="mini-stat-value">${sk ? '—' : (s.completedPct || 0) + '%'}</span>
            <span class="mini-stat-label">Completed</span>
          </div>
        </div>
        <div class="mini-stat ${sk ? 'skeleton-stat' : ''}">
          <div class="mini-stat-icon duration">
            <i class="fa-sharp-duotone fa-solid fa-stopwatch"></i>
          </div>
          <div class="mini-stat-content">
            <span class="mini-stat-value">${sk ? '—' : callsService.formatDuration(s.avgDuration || 0)}</span>
            <span class="mini-stat-label">Avg Duration</span>
          </div>
        </div>
        <div class="mini-stat ${sk ? 'skeleton-stat' : ''}">
          <div class="mini-stat-icon minutes">
            <i class="fa-sharp-duotone fa-solid fa-clock"></i>
          </div>
          <div class="mini-stat-content">
            <span class="mini-stat-value">${sk ? '—' : (s.totalMinutes || 0).toLocaleString()}</span>
            <span class="mini-stat-label">Total Minutes</span>
          </div>
        </div>
      </div>
    `;
  }
}

customElements.define('calls-stats-bar', CallsStatsBar);
